import React from "react";
import { C, Button, GlassCard } from "@coremonit/design-system";
import { AlertTriangle, RotateCcw } from "lucide-react";

interface State { error: Error | null }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
        <GlassCard style={{ padding: 32, maxWidth: 520, textAlign: "center" }} accent={C.redDim}>
          <div style={{ width: 48, height: 48, borderRadius: 16, background: C.redDim, border: `1px solid rgba(239,68,68,0.4)`, color: C.red, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
            <AlertTriangle size={22} />
          </div>
          <h2 style={{ color: C.text, fontSize: 16, fontWeight: 700, margin: "0 0 8px" }}>Something went wrong</h2>
          <p style={{ color: C.textMuted, fontSize: 12, marginBottom: 20 }}>{this.state.error.message}</p>
          <Button variant="secondary" icon={<RotateCcw size={12} />} onClick={this.reset}>Retry</Button>
        </GlassCard>
      </div>
    );
  }
}
